import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ ref, className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full max-w-full min-w-0 bg-transparent pr-3 py-1 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "border-0 border-b-1 border-gray-300 rounded-none focus:border-primary focus:border-b-2 focus-visible:ring-0 focus-visible:ring-offset-0",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        "box-border overflow-hidden text-ellipsis",
        className
      )}
      {...props}
    />
  )
}

export { Input }
